import { useStorage } from '@vueuse/core'
import type { Recipe } from '@/types/Recipe'

export default function usePinned() {
  // NOTE: this intermediary ref is necessary for handling SSR hydration conflicts
  const pinned = ref<Recipe[]>([])
  const pinnedStorage = useStorage<Recipe[]>('juss-pinned', [])
  onMounted(() => watch(pinnedStorage, (val) => (pinned.value = val), { immediate: true }))

  function togglePinned(recipe: Recipe) {
    const index = pinnedStorage.value.findIndex(({ id }) => id === recipe.id)
    if (index !== -1) return pinnedStorage.value.splice(index, 1)
    pinnedStorage.value.push(recipe)
  }

  function isPinned(recipe: Recipe) {
    return Boolean(pinned.value.find(({ id }) => id === recipe.id))
  }

  return { pinned, togglePinned, isPinned }
}
